import { render, staticRenderFns } from "./VetroIcon.vue?vue&type=template&id=238b7c27"
import script from "./VetroIcon.vue?vue&type=script&lang=ts"
export * from "./VetroIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports